<template>
    <div class="form-group">
        <label :for="getFieldId" v-text="placeholder"></label>
        <select :value="value"
                :name="name"
                :id="getFieldId"
                :required="required"
                :readonly="readonly"
                :disabled="disabled"
                class="form-control"
                @change="updateValue($event.target.value)">
            <option value="">Select option...</option>
            <slot></slot>
        </select>
    </div>
</template>

<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        methods: {
            updateValue(value) {
                this.$emit('input', value);
                this.$emit('change', value);
            }
        },
    }
</script>